import { IPublishTerms, IPublishTermsState } from '../../../types/reducers/publishTerms';
import { mergeId } from './mergeId';
import { getPlacingType } from './getPlacingType';

interface IMergePublishTermsParams {
  prevTerms: IPublishTermsState;
  nextTerms: IPublishTermsState;
}

/**
 *
 * @description Мержит услуги размещения, сохраняя при этом предыдущее состояние
 */
export function mergePublishTerms(params: IMergePublishTermsParams): IPublishTerms {
  const { prevTerms, nextTerms } = params;

  const selectedServiceId = mergeId(prevTerms.selectedServiceId, nextTerms.selectedServiceId, nextTerms.serviceIds);
  const selectedPackageId = mergeId(prevTerms.selectedPackageId, nextTerms.selectedPackageId, nextTerms.packageIds);
  const periodsInfo = !!selectedServiceId && nextTerms.periodsByService[selectedServiceId];

  const selectedPeriodId = periodsInfo
    ? mergeId(prevTerms.selectedPeriodId, nextTerms.selectedPeriodId, periodsInfo.periodIds)
    : null;

  const selectedPlacingType = getPlacingType({
    isUserInteraction: prevTerms.isPlacingTypeChangedByUser,
    prevTerms,
    nextTerms,
  });

  return {
    ...nextTerms,
    selectedPlacingType,
    selectedPackageId,
    selectedServiceId,
    selectedPeriodId,
  };
}
